$(document).ready(function(){
    $('.add-to-cart-btn-promo').on('click', function(){
        var variantId = $(this).attr('data-id');
        // if two values split and add both to cart
        if (variantId.indexOf(',') > -1) { 
            variantId.split(',');
            var mult = variantId.split(',');
            CartJS.addItem(mult[0], 1);
            CartJS.addItem(mult[1], 1);
        } else {
            CartJS.addItem(variantId, 1);
        } 
        setTimeout(function(){
            var cartWrapper = document.querySelector('.cart-wrapper');
            if (!cartWrapper.classList.contains('open')) {
				document.documentElement.classList.add('coto_lock-scroll');
				document.documentElement.classList.add('content-overlay');
				cartWrapper.classList.add('open');
			}
        }, 500);
    });
});